import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import './VisionPage.css';

function VisionPage({ onLoginClick }) {
  return (
    <Layout onLoginClick={onLoginClick}>
      <div className="vision-page">
        <section className="vision-hero">
          <div className="vision-hero-bg" />
          <div className="vision-hero-overlay" />
          <div className="vision-hero-content">
            <h1>Our Vision</h1>
            <p>A future where no farmer loses produce to transport barriers</p>
          </div>
        </section>

        <section className="vision-content">
          <div className="vision-content-inner">
            <h2>Connected Supply Chains for All</h2>
            <p>
              We envision a future where no farmer loses produce to transport barriers — where every 
              harvest reaches its market, every community thrives through connected supply chains, and 
              agricultural logistics work for the people who grow our food.
            </p>
            <p>
              Transport gaps in rural areas lead to spoilage, lost income, and food waste. Our vision 
              is to close those gaps by making reliable logistics accessible to every farmer — regardless 
              of location, device, or language. When farmers can move their produce efficiently, entire 
              communities benefit from stronger local economies and better food security.
            </p>
            <p>
              Through technology that works where farmers are — on basic phones, in their 
              preferred language — we are building a logistics network that scales with the needs of 
              smallholder farmers. Together, we can create a future where transport is never the barrier 
              between farm and market.
            </p>
          </div>
        </section>

        <section className="vision-cta">
          <div className="vision-cta-inner">
            <h2>Learn More</h2>
            <p>Explore our mission and get in touch.</p>
            <div className="vision-cta-buttons">
              <Link to="/mission" className="btn-mission">Our Mission</Link>
              <Link to="/contact" className="btn-contact">Contact Us</Link>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default VisionPage;
